
<div class="report-content" data-app>
  <div
    v-if="isLoading"
    class="d-flex justify-content-center align-items-center py-4 h-100"
  >
    <v-progress-circular color="primary" indeterminate></v-progress-circular>
  </div>

  <div
    v-else-if="!selectedColumns.length"
    class="w-100 h-100 d-flex justify-content-center align-items-center"
  >
    <i class="ma-0">No columns selected or available for preview.</i>
  </div>

  <div class="" v-else>
    <!-- Header Row: Total data on left, pagination + Run Report on right -->
    <div
      class="column-header-row d-flex align-items-center justify-space-between px-2 py-2"
    >
      <div class="d-flex align-items-center">
        <h5 class="ma-0 mr-4">
          Total <b>{{ formattedDataCount }}</b> data based on the applied
          filters.
        </h5>
      </div>
    </div>

    <div
      style="
        height: 1px;
        background-color: #d7d7d7;
        width: calc(100% + 32px);
        margin-left: -16px;
        margin-right: -16px;
      "
    ></div>

    <!-- Column Preview Title Row with Pagination and Run Report -->
    <div
      class="column-title-row d-flex align-items-center justify-content-between mx-2 my-4"
    >
      <h4 class="ma-0 m-0 p-0" style="font-size: 16px">
        <b>Column Preview</b>
      </h4>

      <div class="d-flex align-items-center" style="gap: 16px">
        <!-- Pagination Controls -->
        <ColumnPagination :template-id="templateId" />

        <!-- Run Report Button -->
        <button
          class="btn btn-outline-primary d-flex align-items-center"
          @click="runReport"
        >
          <v-icon small color="#007BFF" class="mr-1">mdi-play-circle</v-icon>
          Run Report
        </button>
      </div>
    </div>

    <div class="nav-container">
      <button
        class="btn-vertical prev"
        :class="{ 'btn-vertical-primary': fieldPagination.current_page > 1 }"
        @click="goToPage(fieldPagination.current_page - 1)"
      >
        <v-icon :color="fieldPagination.current_page > 1 ? '#FFF' : '#D7D7D7'"
          >mdi-chevron-left</v-icon
        >
      </button>
      <button
        class="btn-vertical next"
        :class="{
          'btn-vertical-primary':
            fieldPagination.current_page < fieldPagination.total_pages,
        }"
        @click="goToPage(fieldPagination.current_page + 1)"
      >
        <v-icon
          :color="
            fieldPagination.current_page < fieldPagination.total_pages
              ? '#FFF'
              : '#D7D7D7'
          "
          >mdi-chevron-right</v-icon
        >
      </button>
    </div>

    <div
      class="column-container"
      :style="{ marginTop: isShowLegend ? '108px' : '' }"
    >
      <div class="position-relative columns-wrapper">
        <div class="d-flex columns-row" :style="columnsRowStyle">
          <div
            v-for="(column, index) in processedColumns"
            :key="index"
            class="column-item"
          >
            <div class="column-card">
              <div
                class="column-header"
                :class="{ 'data-dummy': column.isDummy }"
              >
                <v-tooltip
                  v-if="!column.isDummy"
                  bottom
                  content-class="tooltip"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <h4
                      v-on="on"
                      class="ma-0"
                      style="
                        font-size: 16px;
                        white-space: nowrap;
                        overflow: hidden;
                        text-overflow: ellipsis;
                      "
                    >
                      <b>{{
                        column.header_name || column.original_header_name
                      }}</b>
                    </h4>
                  </template>
                  <span style="background-color: white">
                    <p class="ma-0">
                      {{ column.header_name || column.original_header_name }}
                    </p>
                    <i style="color: #848484; font-size: 12px">
                      <b>Original Column Name :</b>
                      {{ column.original_header_name }}
                    </i>
                  </span>
                </v-tooltip>
                <div v-else class="d-flex">
                  <v-icon
                    small
                    color="#3F3F3F"
                    class="mr-2"
                    style="padding: 2.5px 0"
                    >mdi-file-document-edit-outline</v-icon
                  >
                  <h4
                    class="ma-0"
                    style="
                      font-size: 16px;
                      white-space: nowrap;
                      overflow: hidden;
                      text-overflow: ellipsis;
                    "
                  >
                    <b>{{
                      column.header_name || column.original_header_name
                    }}</b>
                  </h4>
                </div>
              </div>
              <div
                class="content-container"
                :style="{
                  backgroundColor: column.isDummy ? '#F4F4F4' : '#FFFFFF',
                }"
              >
                <div v-if="column.isQuestionnaire">
                  <template v-if="column.previewData.length">
                    <div
                      class="content-preview"
                      v-for="(item, index) in column.previewData"
                      :key="index"
                    >
                      <h4 class="ma-0" style="font-size: 16px">
                        <span v-if="item || item === 0">{{ item }}</span>
                        <i
                          v-else
                          class="text-muted"
                          style="color: #dddddd !important"
                          >Empty</i
                        >
                      </h4>
                    </div>
                  </template>
                  <div v-else>
                    <i
                      class="text-muted text-center d-block"
                      style="color: #bdbdbd !important"
                      >Preview unavailable. Ensure your organization has data
                      to display.</i
                    >
                  </div>
                </div>
                <div
                  class="d-flex justify-content-center align-items-start position-relative"
                  style="height: 802px; color: #007bff"
                  v-else-if="
                    !showPreview[
                      `${column.category_key || column.group}_${
                        column.columnName
                      }`
                    ]
                  "
                >
                  <button
                    @click="togglePreview(column)"
                    class="d-flex align-items-center"
                    style="
                      position: sticky;
                      top: 60%;
                      transform: translateY(-50%);
                    "
                  >
                    <v-icon
                      small
                      color="#007BFF"
                      class="mr-2"
                      style="height: fit-content"
                      >mdi-eye-outline</v-icon
                    >
                    Show Preview Data
                  </button>
                </div>
                <div
                  v-if="
                    showPreview[
                      `${column.category_key || column.group}_${
                        column.columnName
                      }`
                    ]
                  "
                >
                  <template
                    v-if="
                      previewData[
                        `${column.category_key || column.group}_${
                          column.columnName
                        }`
                      ] &&
                      previewData[
                        `${column.category_key || column.group}_${
                          column.columnName
                        }`
                      ].length > 0
                    "
                  >
                    <div
                      class="content-preview"
                      v-for="(item, index) in previewData[
                        `${column.category_key || column.group}_${
                          column.columnName
                        }`
                      ]"
                      :key="index"
                    >
                      <h4 class="ma-0" style="font-size: 16px">
                        <span v-if="item || item === 0">
                          <span
                            v-if="
                              column.columnName === 'prevailing_wage_cents'
                            "
                            >{{ formatCurrency(item) }}</span
                          >
                          <span v-else>{{ item }}</span>
                        </span>
                        <i
                          v-else
                          class="text-muted"
                          style="color: #dddddd !important"
                          >Empty</i
                        >
                      </h4>
                    </div>
                  </template>
                  <div v-else>
                    <i
                      class="text-muted text-center d-block"
                      style="color: #bdbdbd !important"
                      >Preview unavailable. Ensure your organization has data
                      to display.</i
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <RenameColumnModal
    v-if="showModal"
    :dialog="showModal"
    @toggle-modal="toggleModal"
    :dataColumn="modalData"
  />
</div>
